/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useEffect, useState } from "react";
import * as API from "../../http/api";
import { useHistory } from "react-router-dom";
import { closelightbox } from "../../util/Functions";
import { Grid, TextField, Button, DialogActions, DialogContent, Dialog, DialogTitle, IconButton, MenuItem } from "@mui/material";
import { ModalStyle } from "../../util/Styles";
import { Close } from "@mui/icons-material";

const AlboCard = (props) => {
	const [zPos, setZPos] = useState(45);
  const [disabledButton, setDisabledButton] = useState(true);
  const [codeCountry, setCodeCountry] = useState("52");
  const [errCodeCountry, setErrCodeCountry] = useState("");
  const [formCacao, setFormCacao] = useState({rfc: "", cards: [] });
  const [formAlboCard, setFormAlboCard] = useState({
    personalization: { company_name: "", contact_phone: "", contact_email: "", type_perso: "N02" },
    shipment: { address: { zip: "", town: "", street: "", intnum: "", state: "", locality: "", extnum: "", reference: "", country: "" }},
    customer_uuid: "",
    size: "",
    partner_uuid: "alboCard",
    priority: "normal",
  });
  const [errorsAlboCard, setErrorsAlboCard] = useState({
    personalization: { company_name: "", contact_phone: "", contact_email: "", type_perso: "" },
    shipment: { address: { zip: "", town: "", street: "", state: "", locality: "", extnum: "", reference: "", country: "" }},
    size: "",
  });
  const history = useHistory();
  const [locality, setLocality] = useState([]);
  const [typePersoCat, setTypePersoCat] = useState([]);
  const [defaultCountry, setDefaultCountry] = useState("");
  useEffect(() => {
    for (let c in props.catalogs.country) {
      if (props.catalogs.country[c].v === "Mexico" || props.catalogs.country[c].v === "México") {
        setDefaultCountry(props.catalogs.country[c].k);
        break;
      }
    }

    init();
    //values.cacao.taxid = props.data?.general?.taxid;

    let roles = localStorage.config && JSON.parse(localStorage.config)["idRol"] ? [JSON.parse(localStorage.config)["idRol"]] : [];
    const typePersoCat = new Set();
    for (let r in roles) {
      for (let c in props.catalogs.cardCustomization) {
        const cardCustomization = props.catalogs.cardCustomization[c];
        if ((cardCustomization.m?.[0]?.requester && cardCustomization.m?.[0]?.requester.indexOf(roles[r]) != -1) || roles[r] == "inext-role-IT-Ops") {
          typePersoCat.add(cardCustomization);
        }
      }
    }
    setTypePersoCat(Array.from(typePersoCat));
  }, []);

  const init = () => {
    let fc = formCacao;
    fc.rfc = props.data.general.taxid;
    setFormCacao(JSON.parse(JSON.stringify(fc)));
  };

  const getCatalog = async (name, zip) => {
    props.changeLoader(true);
		setZPos(-1);

    let data = {
      catalog: {
        id: name,
        filters: [{ key: zip }],
      },
    };

    let catalog = await API.service( "getCatalog", data, props.pos, props.changeAlert, props.changeLoader, history);
    props.changeLoader(false);
		setZPos(45);
    return catalog;
  };

  const send = async () => {
    props.changeLoader(true);
		setZPos(-1);

    let fac = formAlboCard;
    fac.customer_uuid = props.data.uuid;
    fac.shipment.address.country = defaultCountry;
    fac.personalization.contact_phone = `+${codeCountry}${fac.personalization.contact_phone}`;
    let response = await API.service( "alboCard", { data: fac }, props.pos, props.changeAlert, props.changeLoader, history);
    if (response.status === 200) {
      if (response.data.data.response == "OK") {
        props.changeAlert( true, "success", "Tarjetas solicitadas correctamente. suiteCase: " + response.data.data.resp.suit_case );
        closelightbox();
      } else {
        fac.personalization.contact_phone = fac.personalization.contact_phone.replace(`+${codeCountry}`, "");
        setFormAlboCard(JSON.parse(JSON.stringify(fac)));
      }
    }

    props.changeLoader(false);
		setZPos(45);
  };

  const validateForm = (f, err, code, error) => {
    if ( f.personalization.company_name && f.personalization.contact_phone && f.personalization.contact_email && f.personalization.type_perso && f.shipment.address.zip && f.shipment.address.town && f.shipment.address.street && f.shipment.address.state && f.shipment.address.locality && f.shipment.address.extnum && f.shipment.address.reference && f.shipment.address.reference && f.size &&
      !err.personalization.company_name && !err.personalization.contact_phone && !err.personalization.contact_email && !err.personalization.type_perso && !err.shipment.address.zip && !err.shipment.address.town && !err.shipment.address.street && !err.shipment.address.state && !err.shipment.address.locality && !err.shipment.address.extnum && !err.shipment.address.reference && !err.shipment.address.reference && !err.size && !error &&
      code ) {
      setDisabledButton(false);
    } else {
      setDisabledButton(true);
    }
  };

  const change = async (object, field, e) => {
    let f = formAlboCard;
    let err = errorsAlboCard;
    let cc = codeCountry;
    let ecc = errCodeCountry;
    if (object == "address") {
      if (field == "zip") {
        if (!isNaN(e.target.value)) {
          f.shipment.address[field] = e.target.value;
        }
      } else {
        f.shipment.address[field] = e.target.value;
      }
      if (!e.target.value) {
        err.shipment.address[field] = "Dato obligatorio";
      } else {
        err.shipment.address[field] = "";
      }

      if (field == "zip") {
        if (f.shipment.address.zip.length < 5) {
          err.shipment.address.zip = "El código postal debe ser de 5 digitos";
        } else {
          err.shipment.address.zip = "";
          let catalog = await getCatalog("zip", e.target.value);
          if (catalog.status == 200 && catalog.data.data.response == "OK") {
            let cat = [];
            f.shipment.address.state = "";
            f.shipment.address.town = "";
            for (let i = 0; i < catalog.data.data.catalog.length; i++) {
              cat.push(catalog.data.data.catalog[i]["m"][0].township);
            }
            setLocality(JSON.parse(JSON.stringify(cat)));
            f.shipment.address.state =
              catalog.data.data.catalog[0]?.["m"]?.[0]?.state_key;
            f.shipment.address.town =
              catalog.data.data.catalog[0]?.["m"]?.[0]?.municipality;
            f.shipment.address.locality = "";
            err.shipment.address.locality = "";
          }
        }
      }
    }

    if (object == "personalization") {
      f.personalization[field] = e.target.value;
      if (!e.target.value) {
        err.personalization[field] = "Dato obligatorio";
      } else {
        err.personalization[field] = "";
      }
    }

    if (!object) {
      if (field == "size") {
        if (!isNaN(e.target.value)) {
          f.size = e.target.value;
        }
      } else {
        f[field] = e.target.value;
      }

      if (!e.target.value) {
        err[field] = "Dato obligatorio";
      } else {
        err[field] = "";
      }

      if (field == "size") {
        if (e.target.value <= 0) {
          err.size = "Número de tarjetas debe ser 1 a 5000";
        } else {
          err.size = "";
        }
      }
    }

    setErrorsAlboCard(JSON.parse(JSON.stringify(err)));
    setFormAlboCard(JSON.parse(JSON.stringify(f)));
    validateForm(f, err, cc, ecc);
  };

  const changeCode = (e) => {
    let f = formAlboCard;
    let er = errorsAlboCard;
    let error = errCodeCountry;
    setCodeCountry(e.target.value);
    if (!e.target.value) {
      error = "Dato obligatorio";
    } else {
      error = "";
    }
    setErrCodeCountry(error);
    validateForm(f, er, e.target.value, error);
  };

  return (
		<Dialog open={true} sx={{zIndex: zPos, filter: zPos !== 45 ? 'blur(2px)': "none" }} fullWidth>
			<ModalStyle property={String(disabledButton)}>
				<DialogTitle >
          <span>
					  Solicitud de Tarjetas
            <p id="subtitle_2">albo Card</p>
          </span>
					<IconButton id="headButton" onClick={closelightbox}><Close/></IconButton>
				</DialogTitle>

        <DialogContent style={{overflowY: "hidden"}}>
          <Grid container spacing={2}>
            <Grid item xs={12} style={{fontWeight: "bolder"}}>
              Datos de Envío y Personalización       
            </Grid>
            <Grid item xs={12}>
              <TextField label={"Nombre comercial de la empresa (Tal cual se debe imprimir en la tarjeta)"} placeholder="Nombre comercial" value={formAlboCard.personalization.company_name} onChange={change.bind( this, "personalization", "company_name" )} error={errorsAlboCard.personalization.company_name !== ""} helperText={errorsAlboCard.personalization.company_name === "" ? errorsAlboCard.personalization.company_name : ''} size="small" fullWidth InputLabelProps={{ shrink: true }} inputProps={{ maxLength: 21}}/>
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="Código Postal" value={formAlboCard.shipment.address.zip} onChange={change.bind(this, "address", "zip")} error={errorsAlboCard.shipment.address.zip !== ""} helperText={errorsAlboCard.shipment.address.zip === "" ? errorsAlboCard.shipment.address.zip : ''} size="small" fullWidth inputProps={{ maxLength: 5}}/>
            </Grid>
            <Grid item xs={6}>
              <TextField  
                label="Estado" value={formAlboCard.shipment.address.state} select disabled error={errorsAlboCard.shipment.address.state !== ""} helperText={errorsAlboCard.shipment.address.state === "" ? errorsAlboCard.shipment.address.state : ''} size="small" fullWidth  >
                {props.catalogs.states?.map((item, index) => (
                  <MenuItem key={`state-${index}`} value={item.k}>{item.v}</MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="Alcaldia / Municipio" value={formAlboCard.shipment.address.town} disabled error={errorsAlboCard.shipment.address.town !== ""} helperText={errorsAlboCard.shipment.address.town === "" ? errorsAlboCard.shipment.address.town : ''} size="small" fullWidth />
            </Grid>
            <Grid item xs={6}>
              <TextField  label="Colonia" value={formAlboCard.shipment.address.locality || ""} select  onChange={change.bind(this, "address", "locality")} error={errorsAlboCard.shipment.address.locality !== ""} helperText={errorsAlboCard.shipment.address.locality === "" ? errorsAlboCard.shipment.address.locality : ''} size="small" fullWidth >
                { locality?.map((item, index) => (
                  <MenuItem key={`shipping-${index}`} value={item}>{item}</MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="Calle" value={formAlboCard.shipment.address.street} onChange={change.bind(this, "address", "street")} error={errorsAlboCard.shipment.address.street !== ""} helperText={errorsAlboCard.shipment.address.street === "" ? errorsAlboCard.shipment.address.street : ''} size="small" fullWidth inputProps={{ maxLength: 50}}/>
            </Grid>

            <Grid item xs={6}>
              <TextField
                label="No. ext." value={formAlboCard.shipment.address.extnum} onChange={change.bind(this, "address", "extnum")} error={errorsAlboCard.shipment.address.extnum !== ""} helperText={errorsAlboCard.shipment.address.extnum === "" ? errorsAlboCard.shipment.address.extnum : ''} size="small" fullWidth inputProps={{ maxLength: 25}}/>
            </Grid>

            <Grid item xs={6}>
              <TextField
                label="No. int." value={formAlboCard.shipment.address.intnum} onChange={change.bind(this, "address", "intnum")} size="small" fullWidth inputProps={{ maxLength: 25}}/>
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="Referencia" value={formAlboCard.shipment.address.reference} onChange={change.bind(this, "address", "reference")} error={errorsAlboCard.shipment.address.reference !== ""} helperText={errorsAlboCard.shipment.address.reference === "" ? errorsAlboCard.shipment.address.reference : ''} size="small" fullWidth inputProps={{ maxLength: 27}}/>
            </Grid>
            <Grid item xs={12} style={{fontWeight: "bolder"}}>
              <hr />
              Datos de quien recibe     
            </Grid>
            <Grid item xs={6} sx={{ display: "flex" }}>
              <TextField
                label="Código País"	value={codeCountry}	onChange={changeCode.bind(this)} select size="small"	sx={{ marginRight: "10px" }} style={{ width: "45%" }} InputLabelProps={{ shrink: true }}	error={errCodeCountry !== ""} helperText={errCodeCountry ? errCodeCountry : ''}>
                {props.catalogs.country.map((item, index) => {
                  return (
                    <MenuItem key={`state-${index}`} value={item.m[0].dial}>
                      (+{item.m[0].dial}) {item.m[0].code2}
                    </MenuItem>
                  );
                })}
              </TextField>
              <TextField
                label="Teléfono" value={formAlboCard.personalization.contact_phone} onChange={change.bind(this, "personalization", "contact_phone")} size="small" style={{ width: "55%" }} InputProps={{ style: { height: "40px"}}} error={errorsAlboCard.personalization.contact_phone !== ""} helperText={errorsAlboCard.personalization.contact_phone ? errorsAlboCard.personalization.contact_phone : ''} inputProps={{ maxLength: 10}}/>
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="Email"	value={formAlboCard.personalization.contact_email} onChange={change.bind(this, "personalization", "contact_email")}	size="small"	fullWidth	error={errorsAlboCard.personalization.contact_email !== ""} helperText={errorsAlboCard.personalization.contact_email ? errorsAlboCard.personalization.contact_email : ''} inputProps={{ maxLength: 50}}/>
            </Grid>

            <Grid item xs={12} style={{fontWeight: "bolder"}}>
              <hr />
              Tarjetas a Solicitar        
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="Cantidad" value={formAlboCard.size} onChange={change.bind(this, "", "size")} size="small" fullWidth error={errorsAlboCard.size !== ""} helperText={errorsAlboCard.size ? errorsAlboCard.size : ''} inputProps={{ maxLength: 4, minLength: 1}}/>
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="Tipo Personalización" value={formAlboCard.personalization.type_perso} select onChange={change.bind(this, "personalization", "type_perso")} size="small" fullWidth error={errorsAlboCard.personalization.type_perso !== ""} helperText={errorsAlboCard.personalization.type_perso ? errorsAlboCard.personalization.type_perso : ''} >
                {typePersoCat.length === 0 ? 
                  <MenuItem value={"N02"}>unnamed</MenuItem>
                  :
                  typePersoCat?.map((item, index) => (
                    <MenuItem key={`type-${index}`} value={item.k}>{item.v}</MenuItem>
                  ))}
              </TextField>
            </Grid>		
          </Grid>
        </DialogContent>

				<DialogActions>    
					<Button id='buttonCancel' variant="outlined" onClick={closelightbox} >Cancelar</Button>     
					<Button disabled={disabledButton} variant="contained" onClick={send.bind(this)}>Solicitar</Button>
				</DialogActions>
			</ModalStyle>
		</Dialog> 
  );
};

export default AlboCard;
